/*
  Keeps the save percentage of the PDP test price block in sync with the prices on screen.
  Liquid already renders the correct values; this only matters when a third party
  (Intelligems price test, currency app) rewrites the price text after render.
*/
(function () {
  const parseAmount = (text) => {
    if (!text) return null;
    const cleaned = text.replace(/[^\d.,]/g, '').replace(/,/g, '');
    const amount = parseFloat(cleaned);
    return isNaN(amount) ? null : amount;
  };

  const refresh = (root) => {
    const currentEl = root.querySelector('[data-pdp-price-current]');
    const compareEl = root.querySelector('[data-pdp-price-compare]');
    const badgeEl = root.querySelector('[data-pdp-price-badge]');
    if (!currentEl || !compareEl || !badgeEl) return;

    const current = parseAmount(currentEl.textContent);
    const compare = parseAmount(compareEl.textContent);

    if (!current || !compare || compare <= current) {
      compareEl.hidden = true;
      badgeEl.hidden = true;
      return;
    }

    const label = Math.round(((compare - current) / compare) * 100) + '% off';
    if (badgeEl.textContent !== label) badgeEl.textContent = label;
    compareEl.hidden = false;
    badgeEl.hidden = false;
  };

  let scheduled = false;
  const refreshAll = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      document.querySelectorAll('[data-pdp-price]').forEach(refresh);
    });
  };

  const observe = () => {
    const observer = new MutationObserver(refreshAll);
    document.querySelectorAll('[id^="price-"]').forEach((container) => {
      observer.observe(container, { subtree: true, childList: true, characterData: true });
    });
    refreshAll();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
